import React from 'react'
import { Redirect, Route } from 'react-router-dom'

type Props = {
  computedProps: Object,
  condition: boolean,
  component: React.FC,
  redirect: string,
}

const ConditionnalRoute = ({
  computedProps = {},
  condition = true,
  component: Comp = null,
  redirect = '/login',
  titlePage,
  ...rest
}: Props) => (
  <Route
    {...rest}
    render={(props) => {
      if (typeof condition === 'function' ? condition() : condition) {
        if (titlePage) document.title = document.title.split(' - ')[0] + ` - ${titlePage}`
        return <Comp {...props} {...computedProps} />
      }

      return <Redirect to={redirect} />
    }}
  />
)

export default ConditionnalRoute
